module.exports = __webpack_public_path__ + "static/neli_-80a364a020abb4abe407ee3a926f55d3.png";